import { QuestionCircleOutlined } from '@ant-design/icons'
import { Popconfirm } from 'antd'
import { Button } from 'components'
import React from 'react'
import { FaTrash } from 'react-icons/fa6'

function DeleteButton({onClick}) {
  return (
    <Popconfirm
      title="Та устгахдаа итгэлтэй байна уу"
      okButtonProps={{className: 'bg-primary'}}
      icon={
        <QuestionCircleOutlined
          style={{
            color: 'red',
          }}
        />
      }
      onConfirm={onClick}
    >
      <Button type='danger' size='sm' icon={<FaTrash/>}/>
    </Popconfirm>
  )
}

export default DeleteButton